module.exports = __webpack_public_path__ + "static/media/29.e00f03b7.jpg";